---
title: Redux
description: "A redux device: a number of bits, a downsample factor and a mix, a panel that draws the stairs the bits make, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-redux" />

Roughens the sound like an early sampler. It keeps only some bits of each sample and holds each sample for several. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="redux" kind="device" />

## Controls

<DeviceControls device="redux">
<Control id="bits">How many bits each sample keeps. At 8 the stairs are too fine to see: take it down to 3 or 4.</Control>
<Control id="hold">How many samples each one is held for.</Control>
<Control id="mix">The balance of the roughened signal and the clean one.</Control>
</DeviceControls>

## Panel

The panel draws the stairs the bits make against the straight line of a clean sound. `quantize(input, bits)` is one step of the quantizer.

<DeviceUsage name="redux" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

The bits are a quantizer table in a `WaveShaperNode`, rebuilt only when they change. The sample hold is an `AudioWorklet` (`REDUX_WORKLET` is its source). Until it is ready the bits are already crushed and the rate is not yet reduced, and `engine.ready` resolves to `false` in a context that cannot run worklets. The hold takes whole samples, not a filtered resampling, so it aliases, which is the sound.
